import { Component, OnInit } from '@angular/core';
 import { AdminService } from './admin.service';
 import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from '@angular/material/snack-bar';
import { Router } from '@angular/router'; 
@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
  allMerchants:any
  horizontalPosition:MatSnackBarHorizontalPosition= 'end';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  activeMerchants: any;
  pendingMerchants: any;
  rejectMerchants: any;
  merchantId: any;
  pendingRequest:boolean=false;
  intialAllMerchants:any
  activeCard: number;
  searchValue:string;
  

  constructor(private adminService:AdminService, private _snackBar:MatSnackBar,
    private router:Router) { }

  ngOnInit(): void {
    this.getAllMerchantsById();
  }



  getAllMerchantsById(){
   this.adminService.getAllMerchants().subscribe(res=>{
    this.intialAllMerchants = res.body.data.sort((a, b) => { return <any>new Date(b.created_at) - <any>new Date(a.created_at); });
      this.allMerchants =res.body.data.sort((a, b) => { return b.created_at - a.created_at; });
      this.pendingMerchants= this.allMerchants.filter(object => object.status === "PENDING_REVIEW");
      this.rejectMerchants= this.allMerchants.filter(object => object.status === "REJECTED");
    })
  }



  verifyMerchant(merchant){
    let request ={   
      "status": "ACTIVE",
      "status_reason": "Test reason."
  }
    this.adminService.updateMerchant(merchant.merchant_id,request).subscribe(response=>{    
    },error=>{
if(error.status == 200){
  this.getAllMerchantsById()
  // this._snackBar.open('Verified Successfully', 'close', {
  //   duration: 3000,
  //   horizontalPosition: this.horizontalPosition,
  //   verticalPosition: this.verticalPosition,
  // });

}
    })
  }

  

  sortRequests(action){
    this.activeCard = null;
    if(action === 'Pending'){
      this.activeCard = 1;
      this.allMerchants= this.pendingMerchants.sort((a, b) => { return b.created_at - a.created_at; });
    }else if(action === 'Rejected'){
      this.activeCard = 2;
      this.allMerchants= this.rejectMerchants.sort((a, b) => { return b.created_at - a.created_at; });
    }else{
    this.allMerchants =this.intialAllMerchants
    }
   
  }

  searchMerchants(event){
    this.allMerchants =  this.intialAllMerchants.filter((obj) =>
  JSON.stringify(obj).toLowerCase().includes(this.searchValue.toLowerCase())
)
  }

}
